module.exports = __webpack_public_path__ + "static/media/Spinner.a9f103ae.gif";